import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import './css/App.css';

import Home from "./components/Home";
import KakaoMap from "./components/Map/KakaoMap";
import CoronaList from "./components/CoronaManage/CoronaList";
import CoronaView from "./components/CoronaManage/CoronaView";

import HeaderAdmin from './components/Header/Header';

import Footer from './components/Footer/Footer';

class App extends Component {
  render () {
  return (
  <>
    <BrowserRouter>
      <HeaderAdmin/> 
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/KakaoMap" component={KakaoMap} />
        <Route path="/CoronaList" component={CoronaList} />
        <Route path="/CoronaView/:cncode" component={CoronaView} />
      </Switch>
      <Footer/> 
    </BrowserRouter>
  </>
  )};
}

export default App;
